import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { postAnswerFormQuestion } from '../../../../../services/forms/formContentService';
import TextAnswer from './TextAnswer';

// выбран вариант «Другое» (allow_other): ответ — текст, а не choices
const OTHER = 'other';

export default function MultipleChoice({ content, session, onAnswer }) {
  const [t] = useTranslation();
  const [fields, setFields] = useState(content?.questionselectcontent);
  const [selected, setSelected] = useState(
    content?.answer?.choices?.[0] ??
      (content?.allow_other && content?.answer?.answer ? OTHER : null),
  );
  const [other, setOther] = useState(content?.answer?.answer ?? '');
  // TextAnswer сохраняет текст с задержкой: к тому времени выбор мог смениться
  const selectedRef = useRef(selected);

  const choose = (next) => {
    selectedRef.current = next;
    setSelected(next);
    const choices = next && next !== OTHER ? [next] : [];
    const body = { choices, session };
    if (content?.allow_other) {
      // выбор в радио-вопросе стирает текст «Другое», и наоборот
      body.answer = null;
      setOther('');
    }
    postAnswerFormQuestion(content.uuid, body)?.then(() => {
      if (!onAnswer) return;
      onAnswer(choices);
      if (content?.allow_other) onAnswer('', 'answer');
    });
  };

  return (
    <form className='flex flex-col gap-4'>
      {fields?.map((field) => {
        return (
          <div key={field?.uuid} className='flex flex-row items-center gap-2'>
            <input
              className='h-5 min-h-[1.25rem] w-5 cursor-pointer'
              type='radio'
              id={`${field?.uuid}`}
              checked={selected === field?.uuid}
              // defaultChecked={}
              name={`${content?.uuid}`}
              onClick={() =>
                choose(selected === field?.uuid ? null : field?.uuid)
              }
            />
            <label className='cursor-pointer' htmlFor={`${field?.uuid}`}>
              {field?.content}
            </label>
          </div>
        );
      })}
      {content?.allow_other && (
        <>
          <div className='flex flex-row items-center gap-2'>
            <input
              className='h-5 min-h-[1.25rem] w-5 cursor-pointer'
              type='radio'
              id={`other-${content.uuid}`}
              checked={selected === OTHER}
              name={`${content?.uuid}`}
              onClick={() => choose(selected === OTHER ? null : OTHER)}
            />
            <label className='cursor-pointer' htmlFor={`other-${content.uuid}`}>
              {t('buttons.other')}
            </label>
          </div>
          {selected === OTHER && (
            <TextAnswer
              content={{
                ...content,
                answer: { ...content.answer, answer: other },
              }}
              session={session}
              onAnswer={(v) => {
                // текст дошёл до бэка уже после выбора другого варианта:
                // бэк записал его и стёр choices — возвращаем выбор
                if (selectedRef.current !== OTHER) {
                  const current = selectedRef.current;
                  postAnswerFormQuestion(content.uuid, {
                    choices: current ? [current] : [],
                    answer: null,
                    session,
                  });
                  return;
                }
                setOther(v);
                if (onAnswer) onAnswer(v, 'answer');
              }}
            />
          )}
        </>
      )}
    </form>
  );
}
